<template>
  <EditorContent v-if="editor" :editor="editor" />
</template>

<script>
import { onBeforeUnmount, watch } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';

import { VariableInput } from '~/components/tiptap/extensions/VariableInput';
import { VariableSelect } from '~/components/tiptap/extensions/VariableSelect';
import { applyDataContentToEditor, disableInteractiveElements } from '~/components/tiptap/utils/datasetHelpers';

export default {
  components: { EditorContent },
  props: {
    modelValue: { type: String, default: '' },
    dataContent: { type: [Array, Object], default: () => [] },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const editor = useEditor({
      editable: false,
      extensions: [StarterKit, VariableInput, VariableSelect],
      content: props.modelValue || '',
      onCreate: ({ editor }) => {
        applyDataContentToEditor(editor, props.dataContent);

        if (props.disabled) {
          disableInteractiveElements(editor);
        }
      },
      onUpdate({ editor }) {
        emit('update:modelValue', editor.getHTML());
      },
    });

    onBeforeUnmount(() => editor.value?.destroy());

    watch(
      [() => props.dataContent, () => editor.value],
      ([dataContent, editorInstance]) => {
        if (!editorInstance) {
          const stop = watch(editor, (val) => {
            if (val) {
              applyDataContentToEditor(val, dataContent);
              stop();
            }
          });
        } else {
          applyDataContentToEditor(editorInstance, dataContent);
        }
      },
      { deep: true, immediate: true },
    );

    return { editor };
  },
};
</script>
